'use client';

import { SnackBar } from '@pixum/snackbar';
import { Icon } from '@pixum/icon';
import { useImageStateStore } from 'stores/express-designer';
import styles from './ErrorSnackbar.module.css';

interface ErrorSnackbarProps {
  constants: Record<string, string>;
}

export function ErrorSnackbar({ constants }: ErrorSnackbarProps) {
  const cartError = useImageStateStore(state => state.cartError);
  const setCartError = useImageStateStore(state => state.setCartError);

  if (!cartError) return null;

  return (
    <div className={styles.wrapper}>
      <SnackBar
        message={constants['i18n_exception_general'] ?? ''}
        linkText={constants['i18n_ok'] ?? ''}
        onClick={() => setCartError(false)}
        theme={{ base: 'ink', accent: 'brand', brightness: 'dark' }}
        icon={<Icon name="warningsignal" ariaHidden />}
      />
    </div>
  );
}
